// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-pF35","newExpiryDate":"styles_newExpiryDate__1fo2g","footer":"styles_footer__3Zx2L"};